import React, { useEffect, useRef, useState } from 'react';
import mermaid from 'mermaid';

mermaid.initialize({
  startOnLoad: false,
  theme: 'default',
  securityLevel: 'loose',
  fontFamily: 'Inter, sans-serif'
});

const MermaidDiagram = ({ chart }) => {
  const containerRef = useRef(null);
  const [svgContent, setSvgContent] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const renderDiagram = async () => {
      try {
        if (!chart) return;
        const id = `mermaid-svg-${Math.random().toString(36).substring(2, 9)}`;
        const { svg } = await mermaid.render(id, chart);
        if (isMounted) {
          setSvgContent(svg);
          setError(false);
        }
      } catch (err) {
        console.error("Mermaid parsing failed", err);
        if (isMounted) {
          setError(true);
        }
      }
    };
    renderDiagram();

    return () => {
      isMounted = false;
    };
  }, [chart]);

  if (error) {
    return (
      <div className="p-4 bg-red-50 text-red-500 rounded-lg text-sm font-mono whitespace-pre-wrap border border-red-100 overflow-x-auto">
        {chart}
      </div>
    );
  }

  return (
    <div 
      ref={containerRef}
      className="mermaid flex justify-center p-4 bg-slate-50/50 rounded-xl my-4 overflow-x-auto border border-slate-100"
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

export default MermaidDiagram;
